import React from 'react'

import PropertiesFilter from '@/housefolios-components/Properties/Filter'
import InvestorFilter from '@/housefolios-components/Investor/InvestorFilter'

import { Button, Tooltip, Box, IconButton, Drawer } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import FilterListTwoToneIcon from '@mui/icons-material/FilterListTwoTone'

import { connect } from 'react-redux'

import { setHeaderDrawerToggle } from '../../reducers/ThemeOptions'

import { searchToolbarIconButtonProps } from '@/theme/skinSx'
import {
  headerDrawerPaperSx,
  drawerBackdropSx,
  drawerModalRootSx,
} from '@/layout-blueprints/chromeComponentSx'

const HeaderDrawer = (props) => {
  const { openFilterDrawer } = props

  const { headerDrawerToggle, setHeaderDrawerToggle } = props

  const toggleHeaderDrawer = () => {
    setHeaderDrawerToggle(!headerDrawerToggle)
  }

  // Handler for investor filter apply/clear
  const handleInvestorApply = (filters) => {
    if (props.onInvestorFilterApply)
      props.onInvestorFilterApply(filters)
    toggleHeaderDrawer()
  }
  const handleInvestorClear = () => {
    if (props.onInvestorFilterClear) props.onInvestorFilterClear()
    toggleHeaderDrawer()
  }

  const filterToolbarBtnProps =
    searchToolbarIconButtonProps(headerDrawerToggle)

  return (
    <>
      {openFilterDrawer && (
        <Tooltip title="Show Filter">
          <Button
            onClick={toggleHeaderDrawer}
            variant="contained"
            color="primary"
            {...filterToolbarBtnProps}
            sx={[
              filterToolbarBtnProps.sx,
              props.propertySearch
                ? {}
                : {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  },
            ]}
          >
            <Box component="span" sx={[{
              height: "20px !important",
              width: "20px !important",
              lineHeight: "20px !important",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0,
            }, { display: "inline-flex" }]}>
              <FilterListTwoToneIcon />
            </Box>
          </Button>
        </Tooltip>
      )}

      <Drawer
        anchor="right"
        open={headerDrawerToggle}
        onClose={toggleHeaderDrawer}
        slotProps={{
          paper: { sx: headerDrawerPaperSx() },
          backdrop: { sx: drawerBackdropSx },
          root: { sx: drawerModalRootSx },
        }}
      >
        <Tooltip arrow title="Close drawer" placement="left">
          <IconButton size="small" onClick={toggleHeaderDrawer} id="CloseFilterDrawerTooltip" aria-label="Close filters" sx={{ backgroundColor: '#253152', color: '#fff', width: 40, height: 40, border: '2px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.45)', '&:hover': { backgroundColor: '#1a2238', }, }} data-hf="close-drawer-btn">
            <CloseIcon sx={{ color: '#fff', fontSize: 22 }} />
          </IconButton>
        </Tooltip>
        <Box sx={{ height: '100%' }}>
          <Box sx={{
            position: "relative",
            height: "100%",
            maxHeight: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
          }}>
            {props.investor ? (
              <InvestorFilter
                onApply={handleInvestorApply}
                onClear={handleInvestorClear}
                {...props}
              />
            ) : (
              <PropertiesFilter
                propertySearch={props.propertySearch}
                lot={props.lot}
                comps={props.comps}
                properties={props.properties}
                getFilteredProperties={props.getFilteredProperties}
                setFilterReset={props.setFilterReset}
                search={props.search}
                getSearchResults={props.getSearchResults}
                setIsSavedFilter={props.setIsSavedFilter}
                activeOrg={props.activeOrg}
                public={props.public}
                toggleDrawer={toggleHeaderDrawer}
              />
            )}
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

const mapStateToProps = (state) => ({
  headerDrawerToggle: state.DeprecatedThemeOptions.headerDrawerToggle,
})

const mapDispatchToProps = (dispatch) => ({
  setHeaderDrawerToggle: (enable) =>
    dispatch(setHeaderDrawerToggle(enable)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderDrawer)
